import React, { useState } from "react";
import { Redirect, Link } from "react-router-dom";

import { useForm } from "react-hook-form";

import { useFirebase } from 'react-redux-firebase'

const Signup = () => {
  const {register, handleSubmit, errors} = useForm();
  const [authError, setAuthError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const firebase = useFirebase();

  console.log(errors);

  const signup = async ({name, companyName, email, password}) => {
    try {
      await firebase.auth().createUserWithEmailAndPassword(email, password);
      await firebase.auth().signInWithEmailAndPassword(email, password);
      await firebase.updateProfile({name, companyName, email})
      setIsSuccess(true);
    } catch (error) {
      setAuthError(error.message);
    }
  }

  if (isSuccess) {
    return <Redirect to="/" />
  }

  return (
    <div className="container">
      <a href="https://narratedbypoise.com" className="logo">Poise</a>
      <a href="https://narratedbypoise.com" className="back back-home">
        <i className="fas fa-long-arrow-alt-left"></i>
        &nbsp;
        Back home
      </a>
      <div className="row justify-content-center text-center mt-5">
        <div className="col-md-12 col-lg-9 col-xl-8 mt-5">
          <div className="card screen signup">
            <div className="row no-gutters">
              <div className="col-md-5">
                <div className="banner" />
              </div>
              <div className="col-md-7">
                <div className="credentials">
                  <h1 className="h3">Create your account</h1>
                  <p>
                    Already have an account? <Link to="/login">Log in</Link>
                  </p>
                  <form className="text-left" onSubmit={handleSubmit(signup)}>
                    <div className="form-group">
                      <label>Name*</label>
                      <input type="text" name="name" className="form-control" ref={register({required: true})}/>
                    </div>
                    <div className="form-group">
                      <label>Company name <small class="text-muted">(optional)</small></label>
                      <input type="text" name="companyName" className="form-control" ref={register}/>
                    </div>
                    <div className="form-group">
                      <label>Email*</label>
                      <input type="text" name="email" className="form-control" ref={register}/>
                    </div>
                    <div className="form-group mb-4">
                      <label>Password*</label>
                      <input type="password" name="password" className="form-control" ref={register}/>
                    </div>
                    { authError && (
                      <p className="alert alert-warning text-center">
                        {authError}
                      </p>
                    )}
                    { errors.name && (
                      <p className="alert alert-warning text-center">
                        Name is a required field.
                      </p>
                    )}
                    <div className="form-group mb-0">
                      <input type="submit" className="btn btn-primary btn-block" value="Create account" />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <p class="text-muted text-center mb-0 pt-5">
            By signing up, you're agreeing to our 
            <span class="break"><a href="https://www.narratedbypoise.com/tos.html" target="blank">Terms of Service</a> &amp; <a href="https://www.narratedbypoise.com/privacy.html" target="blank">Privacy Policy</a></span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Signup;
